// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__Vzu5X","LogoCont":"Logo_LogoCont__iC2lq","NewYear":"Logo_NewYear__LMt2L","IsHeader":"Logo_IsHeader__LJcTb"};